var map = {
	"./BTC.svg": "2e61",
	"./DOGE.svg": "00dc",
	"./ETH.svg": "1b24",
	"./ETHethereum.svg": "84ce",
	"./INXY.svg": "f851",
	"./LTC.svg": "3e66",
	"./USDCoin(BSC).svg": "810b",
	"./USDT(BEP20).svg": "f53e",
	"./USDT(ERC20).svg": "6b0b",
	"./USDT(TRC20).svg": "d21b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8a59";